/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2024 Glowing Blue AG.
 * Authors: Davide Iadeluca.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Extend from 'flarum/common/extenders';
import Activity from './models/Activity';
import AchievementCategory from '../common/models/AchievementCategory';
import Achievement from '../common/models/Achievement';
import AchievementLevel from '../common/models/AchievementLevel';
import UserAchievement from '../common/models/UserAchievement';
import AutomationRule from './models/AutomationRule';

export default [
	new Extend.Store() //
		.add('gamilytics_activities', Activity)
		.add('achievement_categories', AchievementCategory)
		.add('achievements', Achievement)
		.add('achievement_levels', AchievementLevel)
		.add('user_achievements', UserAchievement)
		.add('automation_rules', AutomationRule),
];
